import type { AuthSlice } from "../../schemas/slices/AuthSliceSchema";

export type CareerAccessState = "pending" | "allowed" | "denied";

export function isLocalCareerAuthoring(
    isDevelopment: boolean,
    configuredSource: string | undefined,
): boolean {
    const source = configuredSource?.trim();
    return (
        isDevelopment &&
        (source === undefined || source === "" || source === "local")
    );
}

/** The authenticated response must identify the same account as the caller. */
export function careerAccessFromHeaders(
    headers: Headers,
    userId: string,
): NonNullable<AuthSlice["careerAccess"]> {
    return {
        userId,
        allowed:
            headers.get("X-PB-Career-User-Id") === userId &&
            headers.get("X-PB-Career-Available") === "true",
    };
}

export function careerAccessState(
    auth: Pick<AuthSlice, "bootstrapStatus" | "userId" | "careerAccess">,
    localAuthoring: boolean,
): CareerAccessState {
    if (localAuthoring) return "allowed";
    if (
        auth.bootstrapStatus === "idle" ||
        auth.bootstrapStatus === "authenticating"
    ) {
        return "pending";
    }
    if (auth.bootstrapStatus !== "ready" || auth.userId === null)
        return "denied";
    if (auth.careerAccess?.userId !== auth.userId) return "pending";
    return auth.careerAccess.allowed ? "allowed" : "denied";
}
